module.exports = __webpack_public_path__ + "static/media/truck-icon.7562feb5.png";